import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { ChartUiService } from '../../../services/chart.ui.service';
import { latLng, tileLayer } from 'leaflet';
import { TransportPipe } from '../../../pipes/transport.pipe';
import { AppConfig } from 'src/app/app.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trip-analysis',
  templateUrl: './trip-analysis.component.html',
  styleUrls: ['./trip-analysis.component.scss']
})
export class TripAnalysisComponent implements OnInit {

  public isCharts = true;
  public leafletOptions: any;
  public layers: any[];
  //bar
  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{}], yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function (value) { if (Number(value) % 1 === 0) { return value; } }
        }
      }]
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 30,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public isBarChartLoaded = false;
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = false;
  public barChartPlugins = [pluginDataLabels];
  private dataSet = [];
  public barChartData: ChartDataSets[] = [];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'right',
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          var dataset: any = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat((currentValue / total * 100).toFixed(2));
          return percentage + '%';
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr: any[] = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            sum += parseFloat(data);
          });
          const percentage = (parseFloat(value) * 100 / sum);
          if (percentage == 0) return '';
          return parseFloat(percentage.toFixed(2)) + '%';
        }
      }
    }
  };

  public translateTypeOTransports: string[] = [];
  public translateGenders: string[] = [];

  public pieTypeOfTransports: number[] = [];
  public isPieTypeOfTransportsLoaded = false;
  public pieLabelsTypeOTransports: Label[] = [];
  public pieGender: number[] = [];
  public isPieGenderLoaded = false;
  public pieLabelsGender: Label[] = [];

  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    {
      backgroundColor: [
        '#e57676', '#7eb95e', '#448db2', '#f0b958',
        '#e573a1', '#9cb93f', '#4bb29c', '#f08057',
        '#a6e5b8', '#9ca0b9'
      ],
    },
  ];

  constructor(
    protected chartService: ChartUiService,
    private transportPipe: TransportPipe,
    private config: AppConfig,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {

    this.translate.onLangChange.subscribe((e) => {
      this.translateChartLabels();
    });

    this.chartService.routePerTransportMode().subscribe(response => {
      this.pieTypeOfTransports = response.map(it => it.t2);
      this.translateTypeOTransports = response.map(it => this.transportPipe.transform(it.t1));
      this.translate.get(this.translateTypeOTransports)
        .subscribe(translations => {
          this.pieLabelsTypeOTransports = Object.values(translations)
        });
      this.isPieTypeOfTransportsLoaded = true;
    });
    this.chartService.routePerGender().subscribe(response => {
      this.pieGender = response.map(it => it.t2);
      this.translateGenders = response.map(it => `GENDER_OPTION_${it.t1}`);
      this.translate.get(this.translateGenders)
        .subscribe(translations => {
          this.pieLabelsGender = Object.values(translations)
        });
      this.isPieGenderLoaded = true;
    });
    this.chartService.routePerMonth(2018).subscribe(response => {
      this.barChartLabels = response.map(it => it.t1);
      this.dataSet = response.map(it => it.t2);
      this.barChartData = [
        {
          data: this.dataSet,
          backgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#448db2', '#f0b958'),
          borderColor: '#448db2',
          hoverBackgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#334967', '#ad8b34'),
          hoverBorderColor: '#334967',
          hideInLegendAndTooltip: true
        }
      ];
      this.isBarChartLoaded = true;
    });

    this.barChartData = [
      {
        data: this.dataSet,
        backgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#448db2', '#f0b958'),
        borderColor: '#448db2',
        hoverBackgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#334967', '#ad8b34'),
        hoverBorderColor: '#334967',
        hideInLegendAndTooltip: true
      }
    ];

    let tileLayerOptions = {
      // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.leafletOptions = {
      layers: [
        // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions)
        this.config.getTileLayer()
      ],
      zoom: 14,
      center: latLng(50.848656786354994, 4.349341392517091)
    };
  }

  public onSwitchView() {
    this.isCharts = !this.isCharts;
    this.ngOnInit();
  }

  public translateChartLabels() {
    if (this.translateTypeOTransports.length) {
      this.translate.get(this.translateTypeOTransports)
        .subscribe(translations => {
          this.pieLabelsTypeOTransports = Object.values(translations)
        });
    }
    if (this.translateGenders.length) {
      this.translate.get(this.translateGenders)
        .subscribe(translations => {
          this.pieLabelsGender = Object.values(translations)
        });
    }
  }
}
